module.exports = "<div #svgContainerElem></div>\r\n"